import { useQuery } from "@tanstack/react-query";
import { AIAgent } from "@graylog/enterprise-api";
const INITIAL_POLL_INTERVAL_MS = 3e3;
const MAX_POLL_INTERVAL_MS = 8e3;
const isInFlight = (run) => (run == null ? void 0 : run.state) === "running";
const fetchWorkflowRun = (id) => AIAgent.getRun(id);
const pollInterval = (fetchCount) => Math.min(INITIAL_POLL_INTERVAL_MS * 2 ** fetchCount, MAX_POLL_INTERVAL_MS);
const useWorkflowRun = (id) => useQuery({
  queryKey: ["aiagent", "workflow-runs", "detail", id],
  queryFn: () => fetchWorkflowRun(id),
  enabled: Boolean(id),
  refetchInterval: ({ state }) => isInFlight(state.data) && pollInterval(state.dataUpdateCount),
  // A run in flight is never stale; a finished one never changes.
  staleTime: ({ state }) => isInFlight(state.data) ? 0 : 6e4
});
export default useWorkflowRun;
